/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Base_User_Form_Email_LabelInputs */

const en_base_user_form_email_label = /** @type {(inputs: Base_User_Form_Email_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-Mail`)
};

const de_base_user_form_email_label = /** @type {(inputs: Base_User_Form_Email_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-Mail-Adresse`)
};

/**
* | output |
* | --- |
* | "E-Mail" |
*
* @param {Base_User_Form_Email_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const base_user_form_email_label = /** @type {((inputs?: Base_User_Form_Email_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Base_User_Form_Email_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_base_user_form_email_label(inputs)
	return en_base_user_form_email_label(inputs)
});